<template>
<section class="u-news u-news__container">
    <div class="u-news-title-wrapper">
        <div class="u-news-title">Новости</div>
        <a href="/media/news/search/?q=&tag_slug=Городская%20среда" target="_blank" class="u-news-all-news-btn">Все новости</a>
    </div>

    <div class="u-news-wrapper">
        <template  v-for="news in filterNews">
            <a :href="news.url" :title="news.title" target="_blank" class="u-news-card">
                <div class="u-news-card__tag">{{ news.tag }}</div>
                <div class="u-news-card__title">{{ news.title }}</div>
                <div class="u-news-card__date">{{ format(news.time)[0] }}/<sup>{{ format(news.time)[1] }}</sup></div>
            </a>
        </template>
    </div>

</section>
</template>

<script>
import axios from 'axios';

export default {
    name: 'News',
    props: {},

    data() {
        return {
            urlApi: '/api/public/content/media/news/search/?iblock_code=corporate_news_s1&q=&tag_slug=Городская%20среда',
            newsList: [],
            formattedDate: []
        };
    },
    watch: {
        // Здесь можно добавить наблюдатели
    },

    beforeCreate() {
        // Вызывается до создания экземпляра компонента
    },

    created() {
        // Вызывается после создания экземпляра компонента
    },

    beforeMount() {
        // Вызывается перед монтированием компонента
    },

    mounted() {
        // Вызывается после монтирования компонента
        axios.get(this.urlApi).then(response => {
            this.newsList = response.data.data;
        });
    },

    computed: {
        // Здесь можно добавить вычисляемые свойства
        filterNews() {
                return this.newsList.slice(0, 3);
        }
    },
    methods: {
        // Здесь можно добавить методы
        format(time) {
            return time.split(' ')
        }
    }
};
</script>